import { render, staticRenderFns } from "./PodiumUser.vue?vue&type=template&id=50f09196&scoped=true"
import script from "./PodiumUser.vue?vue&type=script&lang=ts"
export * from "./PodiumUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f09196",
  null
  
)

export default component.exports